import { lazy } from 'react'
import { Redirect } from 'react-router-dom'

const BrandsRoutes = [
  {
    path: '/supplier/cotations',
    component: lazy(() => import('../../views/suppliers/cotations')),
    meta: {
      action: 'true',
      resource: 'supplier_navigation'
    }
  },
  {
    path: '/supplier/orders',
    component: lazy(() => import('../../views/suppliers/orders')),
    meta: {
      action: 'true',
      resource: 'supplier_navigation'
    }
  },
  {
    path: '/supplier/purchase-orders',
    component: lazy(() => import('../../views/suppliers/purchaseOrders')),
    meta: {
      action: 'true',
      resource: 'supplier_navigation'
    }
  }
]

export default BrandsRoutes
